var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    d: "M10.0001 1.66656C7.75014 1.66656 5.66681 2.58323 4.08348 4.16656C2.50014 5.7499 1.66681 7.91656 1.66681 10.1666C1.66681 14.6666 5.33348 18.3332 9.83348 18.3332H10.0001C14.666 18.2499 18.3335 14.4999 18.3335 9.83323C18.3335 5.33323 14.666 1.66656 10.1668 1.66656H10.0001ZM9.33348 6.31665C9.33348 5.89998 9.66681 5.64998 10.0001 5.64998C10.4168 5.64998 10.6668 5.98331 10.6668 6.31665V10.4833C10.6668 10.9 10.3335 11.15 10.0001 11.15C9.58348 11.15 9.33348 10.9 9.33348 10.4833V6.31665ZM9.99998 14.3584C9.40167 14.3584 8.91664 13.8734 8.91664 13.2751C8.91664 12.6768 9.40167 12.1917 9.99998 12.1917C10.5983 12.1917 11.0833 12.6768 11.0833 13.2751C11.0833 13.8734 10.5983 14.3584 9.99998 14.3584Z",
    fill: "#DF7B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b100821b22d926c7cee7e017d32165fc.svg";
export { ForwardRef as ReactComponent };